import React, {Component} from 'react';
import {Pagination, Card, Layout, DataTable, Spinner, EmptyState} from '@shopify/polaris';
import '@shopify/polaris/styles.css';
import './payouts.css';
import {reqPaymentDetail} from "../../api/index";
import memory from '../../utils/memory';
import { Redirect } from 'react-router-dom';
import not_found from '../../assets/not_found.png';

export default class Payouts extends Component{
    constructor(props) {
        super(props);
        this.state = {
            rows:[],
            response_data:[],
            offset:1,
            hasPrevious:false,
            hasNext:false,
            payment_date_order:'asc',
            total_num:0,
            to:0
        }
    }
    
    fetchData = (sort_order) =>{
        reqPaymentDetail(this.state.offset, sort_order).then(
            response => {
                let rows = [];
                let response_data = response.data.success.data;
                for (let index = 0; index < response_data.length; index++) {
                    let items = [];
                    items.push(response_data[index].id);
                    items.push(response_data[index].created_at);
                    items.push('$' + response_data[index].amount);
                    rows.push(items)
                }

                let hasPrevious = response.data.success.prev_page_url === null ? false : true;
                let hasNext     = response.data.success.next_page_url === null ? false : true;
                let to          = response.data.success.to === null ? 0 : response.data.success.to;
                this.setState({response_data:response.data.success, rows:rows, to:to, isLoading:false, hasPrevious:hasPrevious, hasNext:hasNext, total_num:response.data.success.total_num});
            }
            
        ).catch(
            error => {
                console.log(error);
            }
        )
    }

    componentDidMount(){
        this.fetchData('asc');
    }

    next = () =>{
        this.setState({offset:this.state.offset + 1}, this.fetchData);
    }

    prev = () =>{
        this.state.offset > 1 && this.setState({offset:this.state.offset - 1}, this.fetchData);
    }

    //排序
    sort = ()=> {
        let sort_order = this.state.payment_date_order === 'asc' ? 'desc' : 'asc';
        this.setState({payment_date_order:sort_order});
        this.fetchData(sort_order);
    }

    render () {
        if(memory.user_info === '{}')
        {
            return <Redirect to="/login" />
        }

        //定义空值状态
        let empty_state = '';

        if (this.state.response_data.length !==0 && this.state.total_num === 0 ) {
            empty_state = <EmptyState heading="No data" image={not_found} ></EmptyState>;
        }


        //定义spinner
        let payouts_spinner = <div className="payouts_spinner">
            <Spinner accessibilityLabel="Spinner example" size="large" color="teal" />
        </div>
    
        if (this.state.response_data.length !==0 ) {
            payouts_spinner = '';
        }

        const payouts_table = 
        <div className="payouts">
            <Card>
                <DataTable
                columnContentTypes={[
                    'numeric',
                    'text',
                    'text',
                ]}
                headings={[
                    'ID',
                    'Payment date',
                    'Payout amount',
                ]}
                rows={this.state.rows}
                sortable={[false, true, false]}
                onSort={this.sort}
                />

                {payouts_spinner}
                {empty_state}

                <Card.Section>
                    <div className="pagination-section">
                        <span className="pagination-text">{`Showing ${this.state.to} of ${this.state.total_num} results`}</span>
                        <Pagination
                            hasPrevious={this.state.hasPrevious}
                            onPrevious={this.prev}
                            hasNext={this.state.hasNext}
                            onNext={this.next}
                        />
                    </div>
                </Card.Section>
            </Card>
        </div>

        return (
            <div className="home">
                <Layout>
                    <Layout.Section>
                        <h1>Payouts record</h1>
                        <p className="desc-text">You can get 20% commission of whatever the store registered through the referral link spends on a paid plan for SEO Master.</p>
                        {payouts_table}
                        <p className="note-text">Note: Please keep in mind we pay the earning after 20% deduction of Shopify fee.</p>

                    </Layout.Section>
                </Layout>
            </div>

        )
    }
}

